var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 50,
    viewBox: "0 0 27 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.218 42.609H0.618004L0 41.991V0.617996L0.618004 0H6.883L7.501 0.617996V39.67L19.543 20.207L20.206 19.589H25.498L26.161 20.207L26.21 49.133L25.547 49.751H19.327L18.709 49.133L18.66 22.881L6.83601 41.991L6.218 42.609Z",
    fill: "#807CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogo);
export default __webpack_public_path__ + "static/media/sidebar-logo.5af699bf9a8c5e63c947a3a28595c4a3.svg";
export { ForwardRef as ReactComponent };